import { Controller } from "@hotwired/stimulus"

const DATE_MIN = "2010-01-01"
const DATE_MAX = "2099-12-31"
// Note: datetime-local fields are NOT handled here. The min attribute is set
// directly in the ERB templates (e.g. event_reports/_form.html.erb) to avoid
// issues with Stimulus connect() timing and browser step-mismatch validation.
const DATE_INPUT_SELECTOR = 'input[type="date"]'

export default class extends Controller {
  connect() {
    this.element.querySelectorAll(DATE_INPUT_SELECTOR).forEach((input) => {
      if (!input.hasAttribute("min")) {
        input.setAttribute("min", DATE_MIN)
      }
      if (!input.hasAttribute("max")) {
        input.setAttribute("max", DATE_MAX)
      }
    })
  }
}

